import ESTIMATE_CONSTANT from "../constant/estimateConstant"
import type EstimateValues from "../types/params"

type NumberOfLayers = 1 | 2 | 3 | 4 | 6 | 8 | 10 | 12
const getNumberOfLayers = ({ layer }: Pick<EstimateValues, "layer">): NumberOfLayers => {
  switch (layer) {
    case ESTIMATE_CONSTANT.構成層数.片面.value:
    case ESTIMATE_CONSTANT.構成層数.FPC片面.value:
    case ESTIMATE_CONSTANT.構成層数.片面アルミベース.value:
    case ESTIMATE_CONSTANT.構成層数.片面銅ベース.value:
    case ESTIMATE_CONSTANT.構成層数.片面銅ベースポスト.value:
      return 1

    case ESTIMATE_CONSTANT.構成層数["2層"].value:
    case ESTIMATE_CONSTANT.構成層数.FPC2層両面.value:
    case ESTIMATE_CONSTANT.構成層数["2層アルミベース"].value:
    case ESTIMATE_CONSTANT.構成層数["2層アルミコア"].value:
    case ESTIMATE_CONSTANT.構成層数["2層銅ベース"].value:
    case ESTIMATE_CONSTANT.構成層数["2層銅コア"].value:
    case ESTIMATE_CONSTANT.構成層数["2層銅ベースポスト"].value:
    case ESTIMATE_CONSTANT.構成層数["2層銅コアポスト"].value:
      return 2

    case ESTIMATE_CONSTANT.構成層数.FPC3層.value:
      return 3

    case ESTIMATE_CONSTANT.構成層数["4層"].value:
    case ESTIMATE_CONSTANT.構成層数.FPC4層.value:
      return 4

    case ESTIMATE_CONSTANT.構成層数["6層"].value:
      return 6

    case ESTIMATE_CONSTANT.構成層数["8層"].value:
      return 8

    case ESTIMATE_CONSTANT.構成層数["10層"].value:
      return 10

    case ESTIMATE_CONSTANT.構成層数["12層"].value:
      return 12

    default:
      throw new Error("構成層数の値が不正です")
  }
}

export default getNumberOfLayers
